import firebase from 'firebase/app'
import 'firebase/database'
import CryptoJS from 'crypto-js'
import moment from 'moment'
// import zlib from 'zlib'
const zlib = require('zlib')
const firebaseConfig = {
  apiKey: 'AIzaSyCNtwt73wHLu0_1HdaVup9D_ojPASqlFbg',
  authDomain: 'kvadmin-125d3.firebaseapp.com',
  databaseURL: 'https://kvadmin-125d3-default-rtdb.firebaseio.com',
  projectId: 'kvadmin-125d3',
  storageBucket: 'kvadmin-125d3.appspot.com',
  messagingSenderId: '110175065515',
  appId: '1:110175065515:web:0fedecde76d39471422eee',
  measurementId: 'G-JSDV7JC6DH'
}


firebase.initializeApp(firebaseConfig)

const db = firebase.database().ref(`${window.location.hostname.replace(/[^a-zA-Z0-9]/g, '').replace(/[^a-zA-Z0-9]/g, '')}/roomRatio`)
export const GlobalFunction = {
  checkPermission: (permission) => {
    let all_permissions = JSON.parse(localStorage.getItem('userRoles'))
    all_permissions = all_permissions[0].permissions
    if (all_permissions.some(e => e.name === permission)) {
      return true
    } else {
      return false
    }
  },
  getRandomColorImg: () => {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16)
    return `#${  randomColor}`
  },

  saveRoomRatio:() => {
    const data = {
 
      time:Date.now()
     
    }
    db.push(data)
      .then(() => {
          
      })
      .catch(e => {
        console.log(e)
      })
  },

  // encryptValue:(originalValue) => {
    
  //   const secretKey = '********************************'
  //   const encryptedValue = CryptoJS.AES.encrypt(originalValue, secretKey).toString()
  //   console.log(encryptedValue)
  //   const base64UrlEncodedValue = btoa(encryptedValue)
  //     .replace(/\+/g, '-')
  //     .replace(/\//g, '_')
  //     .replace(/=+$/, '')
  //   return base64UrlEncodedValue

  // },
  // decryptValue:(encryptedValue) => {
  //   const secretKey = '********************************'
  //   const base64UrlDecodedValue = encryptedValue
  //     .replace(/-/g, '+')
  //     .replace(/_/g, '/')
  //   const decryptedBytes = CryptoJS.AES.decrypt(atob(base64UrlDecodedValue), secretKey)
  //   const decryptedValue = decryptedBytes.toString(CryptoJS.enc.Utf8)
  //   return decryptedValue
  // },
 
  
  encryptValue:(string) => {
    try {
      const compressedData = zlib.deflateSync(string.toString())
      const encryptedValue = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Latin1.parse(compressedData.toString('binary')))
      const base64UrlEncodedValue = btoa(encryptedValue)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '')
      const uuid = 'xxxxxxxx-xxxx-xxxx'.replace(/x|y/g, () => (Math.random() * 16 | 0).toString(16))
      const combinedString = `${uuid}-${base64UrlEncodedValue}`
      return combinedString
    } catch (err) {
      return null
    }
  },
  
 
  decryptValue:(encryptedString) => {
    if (encryptedString) {
      try {
        const encodedData = encryptedString.slice(19)
        if (!encodedData) {
          return null
        }
        const base64UrlDecodedValue = encodedData 
          .replace(/-/g, '+')
          .replace(/_/g, '/')
        const decodedData = CryptoJS.enc.Latin1.stringify(CryptoJS.enc.Base64.parse(atob(base64UrlDecodedValue)))
        if (!decodedData) {
          return null
        }
        const decompressedData = zlib.inflateSync(Buffer.from(decodedData, 'binary'))
        return decompressedData ? decompressedData.toString() : null

 
      } catch (err) {
        return null
      }
    }
  },
  buttonDisabled (action, id) {
    const btn = document.getElementById(id)
    if (btn) {
      btn.disabled = action
    }
  },
  getTimeAccordingToTimezone (time, zone) {
   
    if (zone) {
      zone = zone.replaceAll(' ', '')
      try {
        return  moment.utc(time).tz(zone).format('MM/DD/YYYY h:mm A')
      } catch (e) {
        return moment.utc(time).local().format('MM/DD/YYYY h:mm A')
      }
    } 
    return moment.utc(time).local().format('MM/DD/YYYY h:mm A')
  }

}